import { useCallback } from 'react';
import { useAppSelector, useAppDispatch } from '../store/hooks';
import { loginUser, logoutUser, getCurrentUser, clearError } from '../store/slices/authSlice';
import { clearPreferences } from '../store/slices/preferencesSlice';

export const useAuth = () => {
  const { user, token, isLoading, error, isAuthenticated } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();

  const login = useCallback(async (email: string, password: string) => {
    return dispatch(loginUser({ email, password })).unwrap();
  }, [dispatch]);

  const logout = useCallback(async () => {
    try {
      console.log('useAuth: Starting logout process');
      // Clear preferences first
      dispatch(clearPreferences());
      console.log('useAuth: Preferences cleared');
      
      // Then logout - use unwrap to get the actual result
      const result = await dispatch(logoutUser()).unwrap();
      console.log('useAuth: Logout completed', result);
      return result;
    } catch (error) {
      console.error('useAuth: Logout error (ignoring):', error);
      // Always succeed logout even if there's an error
      return { success: true };
    }
  }, [dispatch]);

  const refreshUser = useCallback(async () => {
    return dispatch(getCurrentUser());
  }, [dispatch]);

  const clearAuthError = useCallback(() => {
    dispatch(clearError());
  }, [dispatch]);

  return {
    user,
    token,
    isLoading,
    error,
    isAuthenticated,
    login,
    logout,
    refreshUser,
    clearAuthError,
  };
};
